import { gql } from '../../../__generated__/graphql/catalog'

export const FETCH_ZIDI_CART_VARIANTS = gql(`
  query getZidiCartVariants($skus: [String]) {
    variants(skus: $skus) {
      nodes {
        category
        isLowInventory
        color
        rawColor
        discountPrice
        externalParentId
        fit
        rawFit
        image {
          source
        }
        priceDetails {
          discountPrice {
            amount
          }
          price {
            currency
            amount
            base {
              amount
              currency
            }
          }
        }
        price
        product {
          availableForSale
          finalSale
          handle
          swPromoEligible
          exclusive
        }
        productGroup {
          genderCategory
          rawCategory
          style
          handle
          title
        }
        shopifyId
        sku
        size
        rawSize
        style
      }
    }
  }
`)
